import { updateServiceFees } from '../../../actions/ServiceFees/updateServiceFees';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {
	const isRestrict = await dispatch(demoRestriction({}));
	if (isRestrict) return;
	dispatch(
		updateServiceFees(
			values.guestType,
			values.guestValue,
			values.hostType,
			values.hostValue,
			values.currency
		)
	);
}

export default submit;
